export enum ReturnType {
  GOOD_RETURN = "good",
  DAMAGED_RETURN = "damaged",
  EXPIRE_RETURN = "expire",
}

export const ReturnTypeInfo = {
  [ReturnType.GOOD_RETURN]: { code: "good", name: "Good" },
  [ReturnType.DAMAGED_RETURN]: { code: "damaged", name: "Damaged" },
  [ReturnType.EXPIRE_RETURN]: { code: "expire", name: "Expire" },
} as const;

export const getReturnTypeCode = (value: ReturnType): string =>
  ReturnTypeInfo[value].code;
export const getReturnTypeName = (value: ReturnType): string =>
  ReturnTypeInfo[value].name;
